var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('productList',{ref:"productList",attrs:{"loading":_vm.loading,"finished":_vm.finished},on:{"moreClick":_vm.moreClick}})}
var staticRenderFns = []

export { render, staticRenderFns }